module.exports = __webpack_public_path__ + "img/OCN.6a90e08e.svg";